/**
 * 封装的localStorage
 */
import config from "@/config";

const PREFIX = config.db_prefix;

class LocalStorage {
  constructor() {
    this.localStorage = window.localStorage;
    this.prefix = PREFIX;
  }

  set(key, val, fn) {
    let value = "";
    try {
      value = JSON.stringify(val);
    } catch (e) {
      throw new Error("JSON非正常转换");
    }
    this.localStorage.setItem(this.prefix + key, value);
    fn && fn();
  }

  get(key) {
    if (!key) {
      throw new Error("没有对应的key");
    }
    if (typeof key === "object") {
      throw new Error("key不能是一个对象");
    }

    let val = this.localStorage.getItem(this.prefix + key);
    if (val) {
      try {
        val = JSON.parse(val);
      } catch (e) {
        throw new Error(e);
      }
    }

    return val;
  }

  remove(key) {
    this.localStorage.removeItem(this.prefix + key);
  }

  clear() {
    this.localStorage.clear();
  }
}

export default new LocalStorage();
